import React from "react";
import { useModalState } from "../../helpers/ModalProvider";
import { Flex, Text } from "@chakra-ui/react";
import { Button } from "../../components/ui/button";
import {
  DialogBody,
  DialogCloseTrigger,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogRoot,
  DialogTitle,
  DialogDescription,
} from "../../components/ui/dialog";

const PrepaidKeyRefilledModal: React.FC = () => {
  const {
    isPrepaidRefilledModalVisible,
    setPrepaidRefilledModalVisible,
    prepaidRefilledDetails,
  } = useModalState();

  const apiKey = prepaidRefilledDetails?.apiKey || "—";
  const credits = prepaidRefilledDetails?.credits || 0;

  // Truncate key for display
  const keyDisplay = apiKey.length > 24
    ? `${apiKey.slice(0, 12)}...${apiKey.slice(-8)}`
    : apiKey;

  return (
    <DialogRoot
      lazyMount
      open={isPrepaidRefilledModalVisible}
      onOpenChange={(e) => setPrepaidRefilledModalVisible(e.open)}
    >
      <DialogContent>
        <DialogHeader>
          <DialogTitle>API key refilled</DialogTitle>
          <DialogDescription>
            You have added more credits to this API key.
          </DialogDescription>
          <DialogCloseTrigger />
        </DialogHeader>

        <DialogBody>
          <Flex direction="column" gap={3}>
            {/* API Key row */}
            <Flex justifyContent="space-between" alignItems="center">
              <Text fontSize="sm" color="fg.muted">API Key:</Text>
              <Text fontSize="sm" fontWeight="bold">{keyDisplay}</Text>
            </Flex>

            {/* Credits row */}
            <Flex justifyContent="space-between" alignItems="center">
              <Text fontSize="sm" color="fg.muted">Credits:</Text>
              <Text fontSize="sm" fontWeight="bold">{credits.toLocaleString()}</Text>
            </Flex>
          </Flex>
        </DialogBody>

        <DialogFooter>
          <Button
            variant="solid"
            colorPalette="gray"
            width="full"
            onClick={() => setPrepaidRefilledModalVisible(false)}
          >
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </DialogRoot>
  );
};

export default PrepaidKeyRefilledModal;
